import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getFormNode, getFormNodeIncludeOther } from 'common/entities/formNode/selectors';
import { getFormNodeLogicRules, getFormNodeIsRequired } from 'common/entities/formLogicRule/selectors';
import { getNodeShouldBeDisabled } from '../selectors';

/**
 *
 * @todo Currently this connector is called with id '0', no node found. This makes this fragile.
 *       we need to stop connecting things that are not meant to be connected to nodes.
 */
const mapStateToProps = (state, props) => {
    const node = getFormNode(state, props.nodeId);
    const formId = node ? node.formId : undefined;

    return {
        ...node,
        required: getFormNodeIsRequired(state, formId, props.nodeId),
        disabled: getNodeShouldBeDisabled(state, node),
        logicRules: getFormNodeLogicRules(state, formId, props.nodeId),
        includeOther: getFormNodeIncludeOther(state, props.nodeId),
    };
};

/**
 * @param  {function} WrappedComponent
 * @return {function} - WrappedComponent connected to given form node, with its logic rules.
 */
const connectFormNode = (WrappedComponent) => connect(mapStateToProps, {})(WrappedComponent);

connectFormNode.propTypes = {
    nodeId: PropTypes.string.isRequired,
};

export default connectFormNode;
